import React, { useEffect, useState } from 'react';
import axios from 'axios';
const Grocerybasicorder = () => {
  const [data, setData] = useState([]);
  const [order, setOrders] = useState([]);
  const [vendorId, setVendorId] = useState(null);
  const [allOrders, setAllOrders] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(""); // format: YYYY-MM-DD

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const orderItems = order?.items || [];
  const orderId = order?.orderId;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  // Fetch orders from API
  useEffect(() => {
    if (!vendorId) return;

    const fetchOrders = async () => {
      const token = localStorage.getItem("authToken");
      const vendorId = localStorage.getItem("vendorId");
      if (!token) {
        console.error("Authorization token missing");
        return;
      }

      try {
        const response = await axios.get(
          `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/getall/${vendorId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const orders = response.data || [];
        console.log("✅ Orders fetched:", orders);

        // 🟢 Show data in alert (formatted for readability)
        alert("Fetched Orders:\n\n" + JSON.stringify(orders, null, 2));

        setAllOrders(orders);
        setFilteredData(orders);
      } catch (error) {
        console.error("❌ Error fetching orders:", error);
        alert("Error fetching orders:\n" + (error.response?.data?.message || error.message));
      }
    };

    fetchOrders();
  }, [vendorId]);



  useEffect(() => {
    if (!vendorId) return;

    const fetchOrders = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.warn("Auth token missing. Skipping order fetch.");
        return;
      }

      try {
        // 1️⃣ Fetch normal orders
        const ordersRes = await axios.get(
          `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/getall/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        // Filter normal orders based on status
        const processingOrders = ordersRes.data.filter(order =>
          ["CONFIRMED", "PROCESSING", "ORDER_IS_READY", "WAITING_FOR_PICKUP"].includes(order.status)
        );

        // 2️⃣ Fetch TABLE_DINE_IN orders for relevant statuses
        const dineInStatuses = ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP", "COMPLETED"];
        const dineInPromises = dineInStatuses.map(status =>
          axios.get(
            `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/${status}`,
            { headers: { Authorization: `Bearer ${token}` } }
          )
        );

        const dineInResponses = await Promise.all(dineInPromises);
        let dineInOrders = dineInResponses.flatMap(res => res.data || []);

        // Filter TABLE_DINE_IN orders by cartItems status
        dineInOrders = dineInOrders.filter(order =>
          Array.isArray(order.cartItems) &&
          order.cartItems.some(item =>
            ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"].includes(item.orderStatus)
          )
        );

        // 3️⃣ Combine normal and TABLE_DINE_IN orders and remove duplicates
        const combinedOrders = [...processingOrders, ...dineInOrders];
        const uniqueOrders = combinedOrders.filter(
          (order, index, self) =>
            index === self.findIndex(
              o => (o.cartId && o.cartId === order.cartId) || (o.orderId && o.orderId === order.orderId)
            )
        );

        setOrders(uniqueOrders);
        // console.log("✅ Final Unique Orders:", uniqueOrders);
      } catch (error) {
        console.error("❌ Failed to fetch orders:", error.response?.data || error.message);
      }
    };

    fetchOrders();
    const intervalId = setInterval(fetchOrders, 1000); // Fetch every 1 second
    return () => clearInterval(intervalId);
  }, [vendorId]);







  // Filter orders whenever selectedDate changes
  useEffect(() => {
    if (!selectedDate) {
      setFilteredData(allOrders); // show all if no date selected
      return;
    }

    const filtered = allOrders.filter((order) => {
      const orderDate = new Date(order.orderDateAndTime)
        .toISOString()
        .split("T")[0]; // format YYYY-MM-DD
      return orderDate === selectedDate;
    });

    setFilteredData(filtered);
  }, [selectedDate, allOrders]);




  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId);
    }
  }, []);

  const [combinedData, setCombinedData] = useState([]);

  useEffect(() => {
    if (!vendorId) return;

    const fetchData = () => {
      const token = localStorage.getItem("authToken"); // ✅ Retrieve token from storage
      if (!token) {
        console.warn("No auth token found. Skipping fetch.");
        return;
      }

      axios
        .get(
          `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/getall/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // ✅ Include token in header
            },
          }
        )
        .then((res) => setData(res.data))
        .catch((err) =>
          console.error("Error fetching orders with token:", err.response?.data || err.message)
        );
    };

    fetchData(); // initial fetch

    const interval = setInterval(fetchData, 1000); // fetch every 1 second

    return () => clearInterval(interval); // cleanup
  }, [vendorId]);







  const [showDetails, setShowDetails] = useState(false);

  const orderStages = ["Order Placed", "Order Preparing", "Order is Ready", "Order on the way", "Order Delivered"];

  const styles = {
    card: { border: '1px solid #ccc', padding: '16px', margin: '16px', borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)", },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    orderId: { margin: 0, fontWeight: "bold" },
    date: { fontSize: '18px', color: '#000', fontWeight: "bold" },
    pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold", },
    tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
    statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
    arrow: { margin: '0 5px' },
    dropdownBtn: { background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', },
    itemList: { marginTop: '10px', fontWeight: "bold" },
    itemRow: { display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #ddd' }
  };

  // {=======================overview===============================}

  return (

    <div>

    </div>


  );
};


export default Grocerybasicorder;


